import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-metric-card',
  template: `
    <div class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <div class="flex items-start justify-between">
        <div class="min-w-0">
          <p class="text-xs font-medium uppercase tracking-wide text-slate-400">{{ label }}</p>
          <p class="mt-1.5 truncate text-2xl font-semibold tracking-tight text-slate-900">{{ value }}</p>
        </div>
        <div class="ml-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-500">
          <lucide-icon [name]="icon" [size]="20" [strokeWidth]="1.75"></lucide-icon>
        </div>
      </div>
      <div class="mt-4 flex items-center gap-2">
        <span
          class="flex items-center gap-0.5 rounded-full px-2 py-0.5 text-xs font-medium"
          [class.bg-emerald-50]="change > 0"
          [class.text-emerald-700]="change > 0"
          [class.bg-red-50]="change < 0"
          [class.text-red-700]="change < 0"
          [class.bg-slate-100]="change === 0"
          [class.text-slate-500]="change === 0"
        >
          <lucide-icon *ngIf="change > 0" name="arrow-up" [size]="11" [strokeWidth]="2.5"></lucide-icon>
          <lucide-icon *ngIf="change < 0" name="arrow-down" [size]="11" [strokeWidth]="2.5"></lucide-icon>
          {{ change === 0 ? 'No change' : (change > 0 ? '+' : '') + change + '%' }}
        </span>
        <span class="text-xs text-slate-400">vs last month</span>
      </div>
    </div>
  `,
})
export class MetricCardComponent {
  @Input() label = '';
  @Input() value = '';
  @Input() change = 0;
  @Input() icon = 'activity';
}
